import { render, staticRenderFns } from "./user-message-dialog.vue?vue&type=template&id=e2a8c8b6&scoped=true"
import script from "./user-message-dialog.vue?vue&type=script&lang=js"
export * from "./user-message-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-message-dialog.vue?vue&type=style&index=0&id=e2a8c8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a8c8b6",
  null
  
)

export default component.exports